// Actions
const SET_MOTIVO_MALA_CALIDAD = '@motivoMalaCalidad/set'
const CLEAR_MOTIVO_MALA_CALIDAD = '@motivoMalaCalidad/clear'

// Initial state
const INITIAL_STATE = ''

// Reducer
export default function motivoMalaCalidadReducer (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_MOTIVO_MALA_CALIDAD:
      return action.payload
    case CLEAR_MOTIVO_MALA_CALIDAD:
      return ''
    default:
      return state
  }
}

// Action creators
export function setMotivoMalaCalidad (motivo) {
  return { type: SET_MOTIVO_MALA_CALIDAD, payload: motivo }
}

export function clearMotivoMalaCalidad () {
  return { type: CLEAR_MOTIVO_MALA_CALIDAD }
}
